module.exports = __webpack_public_path__ + "img/北京市古树树牌.907b676a.png";